(() => {
  if (window.solaveIntroInstalled) return;
  window.solaveIntroInstalled = true;

  const forcePreview = new URLSearchParams(window.location.search).get('sv-intro-preview') === '1';
  const duration = forcePreview ? 12000 : 3400;
  if (forcePreview) document.documentElement.classList.add('sv-intro-preview');
  const init = root => {
    const homes = [...root.querySelectorAll('.sv-home')];
    if (root.matches?.('.sv-home')) homes.unshift(root);

    homes.forEach(home => {
      if (home.dataset.introReady) return;
      home.dataset.introReady = 'true';
      let timer;

      const stop = () => {
        clearTimeout(timer);
        home.classList.remove('sv-intro-playing', 'sv-intro-soft');
        delete home.dataset.introSeason;
        document.documentElement.classList.remove('sv-intro-open');
      };

      const play = () => {
        stop();
        const season = document.documentElement.dataset.solaveSeason || '';
        const theme = window.solaveSeasonTheme;
        home.dataset.introSeason = season || 'standard';
        const art = home.querySelector('[data-solave-intro-art]');
        const note = home.querySelector('[data-solave-intro-note]');
        if (art) art.innerHTML = season && theme ? theme.introArt : '';
        if (note) note.textContent = season && theme ? theme.introLabel : '';
        document.documentElement.classList.add('sv-intro-open');
        void home.offsetWidth;
        home.classList.add('sv-intro-playing');
        timer = setTimeout(stop, duration);
      };

      home.addEventListener('keydown', event => {
        if (event.key === 'Escape') stop();
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('sv-motion-in');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12 });

        home.querySelectorAll('.sv-product, .sv-steps article, .sv-instagram')
          .forEach(element => observer.observe(element));
      }

      if (window.Shopify?.designMode && !forcePreview) return;

      const startIntro = () => {
        if (home.isConnected) play();
      };

      if ('requestAnimationFrame' in window) {
        requestAnimationFrame(() => requestAnimationFrame(startIntro));
      } else {
        setTimeout(startIntro, 0);
      }

      window.addEventListener('pageshow', event => {
        if (event.persisted && home.isConnected) play();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
})();